'use strict';
module.exports = require('./AccordionTab.vue');